import Numeral from 'numeral';
import Big from 'big.js';
import { HUNDRED } from '../enums/price';

export const priceFormat = (value) => {
	return `฿${Numeral(value).format('0,0.00')}`;
};

export const priceFromAPI = (price) => {
	if (!price) {
		return '';
	}

	const priceValue = new Big(price);
	return priceValue.div(HUNDRED).toFixed(2);
};